var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloat1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.21 173.21C127.272 173.21 83.2152 154.961 50.7321 122.478C18.2489 89.9948 0 45.9381 0 0H173.21",
    fill: "#00C0BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173.21,
    height: 173.21,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloat1);
export default __webpack_public_path__ + "static/media/float-1.78745728a0f82f002b51ed4e26e7e487.svg";
export { ForwardRef as ReactComponent };